import { Step1NunaKey, Step2NunaKey, Step3NunaKey } from 'assets'

export interface StepItem {
  number: string
  color: string
  text: string
  image: string
}

export const STEPS_DATA: StepItem[] = [
  {
    number: '1',
    color: '#E4CF55',
    text: 'Sube tu documento',
    image: Step1NunaKey,
  },
  {
    number: '2',
    color: '#C76A27',
    text: 'Sube tu firma electrónica',
    image: Step2NunaKey,
  },
  {
    number: '3',
    color: '#6D8F2B',
    text: 'Firma tus documentos totalmente gratis',
    image: Step3NunaKey,
  },
]
